var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlan = function SvgPlan(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.997 511.997",
    style: {
      enableBackground: "new 0 0 511.997 511.997"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#313B57"
    },
    cx: 255.998,
    cy: 255.998,
    r: 255.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAEA"
    },
    d: "M497.96,339.83c-34.711,100.215-129.932,172.166-241.955,172.166 c-41.043,0-79.83-9.655-114.217-26.822C88.897,384.102,46.61,277.68,15.671,167.622c-5.193-18.453-10.062-37.02-14.608-55.672 c-4.932-20.229,7.784-40.563,28.128-45.024c24.607-5.392,49.204-10.794,73.811-16.196c68.701-15.067,137.393-30.145,206.094-45.212 c7.074-1.546,14.137-3.103,21.211-4.65c0.042-0.01,0.073-0.021,0.115-0.021c11.41-2.466,22.737,0.596,31.18,7.45 c6.081,4.911,10.668,11.786,12.706,19.957c0.063,0.251,0.125,0.512,0.199,0.763c9.801,39.152,21.452,77.761,34.92,115.68 c1.264,3.563,2.55,7.126,3.845,10.679C436.49,219.02,464.816,280.7,497.96,339.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8AA72"
    },
    cx: 118.104,
    cy: 257.67,
    r: 12.963
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8AA72"
    },
    cx: 191.947,
    cy: 235.946,
    r: 12.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F64C4C"
    },
    d: "M233.381,291.273l2.953,10.035c1.844,6.268-0.167,13.062-5.185,17.247 c-3.047,2.541-6.22,4.954-9.514,7.226c-11.31,7.812-24.035,13.981-37.94,18.071c-14.595,4.294-29.344,5.96-43.73,5.275 c-2.716-0.13-5.418-0.343-8.103-0.637c-6.632-0.728-12.192-5.335-14.075-11.735l-3.106-10.558 c-1.373-4.666,0.255-9.697,4.098-12.677l28.636-22.186l39.567-11.641l36.088,3.143C227.916,283.26,232.008,286.607,233.381,291.273z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6CE9F"
    },
    d: "M167.844,289.994L167.844,289.994c-20.448,6.016-41.902-5.683-47.918-26.131l-13.984-47.528 l74.049-21.787l13.984,47.528C199.992,262.524,188.293,283.978,167.844,289.994z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#863924"
    },
    d: "M116.129,222.068l-9.762,9.14l7.722,26.242l0,0c6.329-1.862,9.95-8.502,8.087-14.831 L116.129,222.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#863924"
    },
    d: "M168.595,184.697l11.459-3.372l15.358,52.197l0,0c-6.329,1.862-12.969-1.759-14.831-8.087 L168.595,184.697z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92482F"
    },
    d: "M170.845,212.236l-64.479,18.971l0,0c-6.024-20.473,5.689-41.951,26.162-47.975l64.479-18.971l0,0 C203.031,184.733,191.318,206.213,170.845,212.236z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF764E"
    },
    cx: 282.591,
    cy: 200.159,
    r: 12.378
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF764E"
    },
    cx: 353.1,
    cy: 179.418,
    r: 12.378
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A6D6"
    },
    d: "M392.664,232.244l2.819,9.582c1.761,5.985-0.159,12.472-4.951,16.467 c-2.909,2.426-5.939,4.73-9.084,6.899c-10.799,7.458-22.949,13.348-36.225,17.255c-13.936,4.1-28.018,5.691-41.754,5.036 c-2.592-0.123-5.173-0.327-7.737-0.609c-6.332-0.695-11.641-5.094-13.438-11.205l-2.966-10.081 c-1.311-4.455,0.243-9.258,3.913-12.104l27.343-21.184l37.779-11.116l34.458,3.001C387.446,224.594,391.352,227.79,392.664,232.244z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D69272"
    },
    d: "M330.088,231.023L330.088,231.023c-19.525,5.745-40.009-5.426-45.754-24.951l-13.352-45.381 l70.704-20.803l13.352,45.381C360.783,204.794,349.612,225.279,330.088,231.023z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M280.709,166.167l-9.321,8.727l7.373,25.057l0,0c6.043-1.778,9.5-8.118,7.723-14.161 L280.709,166.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M330.804,130.484l10.942-3.219l14.664,49.839l0,0c-6.043,1.778-12.383-1.679-14.161-7.723 L330.804,130.484z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5C5C"
    },
    d: "M332.954,156.778l-61.566,18.114l0,0c-5.751-19.548,5.432-40.056,24.98-45.807l61.566-18.114l0,0 C363.685,130.518,352.501,151.027,332.954,156.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313B57"
    },
    d: "M433.197,373.277l-68.135,30.265c-4.952,2.199-10.748-0.031-12.947-4.983l-30.265-68.135 c-2.199-4.952,0.031-10.748,4.983-12.947l68.135-30.265c4.952-2.199,10.748,0.031,12.947,4.983l30.265,68.135 C440.379,365.281,438.149,371.077,433.197,373.277z M366.062,381.629l50.205-22.301l-22.301-50.205l-50.205,22.301L366.062,381.629z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F64C4C"
    },
    d: "M391.962,372.273c-2.294,1.019-4.978,1.164-7.504,0.19l-49.2-18.934 c-5.057-1.946-7.579-7.622-5.632-12.679c1.943-5.055,7.624-7.579,12.678-5.631l40.045,15.411l28.616-74.356 c1.943-5.055,7.624-7.579,12.678-5.631c5.057,1.946,7.579,7.622,5.632,12.679l-32.14,83.511 C396.162,369.36,394.255,371.254,391.962,372.273z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313B57"
    },
    d: "M276.783,446.047l-74.547,30.456c-5.418,2.213-11.602-0.385-13.817-5.801l-30.456-74.547 c-2.213-5.418,0.383-11.602,5.801-13.817l74.547-30.456c5.418-2.213,11.602,0.383,13.817,5.801l30.456,74.547 C284.799,437.648,282.201,443.833,276.783,446.047z M204.032,452.878l54.929-22.441l-22.441-54.929l-54.929,22.441L204.032,452.878 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313B57"
    },
    d: "M109.421,111.351c-4.037,0-7.689-2.771-8.643-6.872c-1.111-4.777,1.862-9.551,6.639-10.663 L287.138,52.02c4.778-1.111,9.551,1.862,10.663,6.639c1.111,4.777-1.862,9.551-6.639,10.663l-179.721,41.796 C110.764,111.276,110.087,111.351,109.421,111.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313B57"
    },
    d: "M146.665,141.972c-3.934,0-7.529-2.633-8.582-6.615c-1.253-4.743,1.577-9.603,6.318-10.855 L276.767,89.54c4.745-1.252,9.603,1.577,10.855,6.318c1.253,4.743-1.577,9.603-6.318,10.855l-132.365,34.962 C148.178,141.876,147.416,141.972,146.665,141.972z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plan.80d739ab.svg";
export { ForwardRef as ReactComponent };